// Versiculo.jsx
import "./Versiculo.css";

export default function Versiculo() {
  return (
    <section className="seccionfrase" data-aos="fade-up">
      <div className="adorno-marco">
        <svg
          className="marco-svg"
          viewBox="0 0 600 120"
          preserveAspectRatio="none"
        >
          {/* SVG decorativo */}
        </svg>
        <p>
          "Y sobre todas las cosas, vistanse de amor, que es el vínculo perfecto." – Colosenses 3:14
        </p>
      </div>
    </section>
  );
}
